import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { BackupLenderGlobalNav } from '~/backup/lender/domains/page/ui/BackupLenderGlobalNav';
import { BackupDealNav } from '~/backup/shared/deal-nav/BackupDealNav';
import { useDealRouteMatch } from '~/backup/shared/deal-nav/useDealRouteMatch';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { AppHeader } from '~/packages/common-frontend/layout/Header';

type Props = { children: React.ReactNode };
export const BackupLenderTemplate = ({
  children,
}: Props): React.ReactElement => {
  const flags = useFeatureFlags();
  // On a deal route, swap the flat portal nav for the deal-scoped sidebar.
  const deal = useDealRouteMatch();
  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        {deal ? (
          <BackupDealNav
            implementationId={deal.implementationId}
            subPath={deal.subPath}
            backTo="/portfolio"
            backLabel="Portfolio"
            showStrats={flags.productsBackupStratsPermissions === 'allow'}
            showSettings
          />
        ) : (
          <BackupLenderGlobalNav />
        )}
        <Box width="100%" overflowX="auto">
          {children}
        </Box>
      </Flex>
    </>
  );
};
